import React, { FunctionComponent } from 'react';
import { StyleSheet, Text, View } from 'react-native';
import Theme from '../../theme';
import { defaultScale } from '../../utils/scaling';
export interface IDividerProps {
  text: string;
  styles: any;
  dividerStyles?: any;
  textStyles?: any;
}

export const Divider: FunctionComponent<IDividerProps> = ({ text, ...props }) => {
  return (
    <View style={[styles.divider, props.styles]}>
      <View style={[styles.dividerDash, props.dividerStyles]}/>
      <Text style={[styles.dividerText, props.textStyles]}>{text}</Text>
      <View style={[styles.dividerDash, props.dividerStyles]}/>
    </View>
  );
};

const styles = StyleSheet.create({
  divider: {
    flexDirection: 'row',
  },
  dividerDash: {
    backgroundColor: Theme.GREY_LIGHT,
    height: defaultScale(2),
    flex: 1,
    alignSelf: 'center',
  },
  dividerText: {
    ...Theme.textStyle.heading,
    alignSelf: 'center',
    paddingHorizontal: defaultScale(5),
    color: Theme.BLACK,
  },
});
